import {
  BillingSolutionRange,
  BillingSolutionRangeInterface,
} from './billingSolutionRange';

export interface BillingSolutionInterface {
  id: string;
  name: string;
  createClaimsBy: 'note' | 'daily' | 'weekly' | 'monthly';
  totalUnitsBy: 'note' | 'day' | 'period';
  unitConversionType: 'ratio' | 'ratio_partial' | 'range';
  unitConversionMinutes: number;
  unitConversionUnits: number;
  unitConversionUnitType: 'whole_unit' | 'half_unit' | 'quarter_unit' | null;
  createdAt: string;
  updatedAt: string;
  billingSolutionRanges?: BillingSolutionRange[];
  billingSolutionRangesAttributes?: BillingSolutionRangeInterface[] | undefined;
}

export class BillingSolution implements BillingSolutionInterface {
  id: string;
  name: string;
  createClaimsBy: 'note' | 'daily' | 'weekly' | 'monthly';
  totalUnitsBy: 'note' | 'day' | 'period';
  unitConversionType: 'ratio' | 'ratio_partial' | 'range';
  unitConversionMinutes: number;
  unitConversionUnits: number;
  unitConversionUnitType: 'whole_unit' | 'half_unit' | 'quarter_unit' | null;
  createdAt: string;
  updatedAt: string;
  billingSolutionRanges?: BillingSolutionRange[];

  constructor(data: Partial<BillingSolutionInterface>) {
    this.id = data.id || '';
    this.name = data.name || '';
    this.createClaimsBy = data.createClaimsBy || 'note';
    this.totalUnitsBy = data.totalUnitsBy || 'note';
    this.unitConversionType = data.unitConversionType || 'ratio';
    this.unitConversionMinutes = data.unitConversionMinutes || 0;
    this.unitConversionUnits = data.unitConversionUnits || 0;
    this.unitConversionUnitType = data.unitConversionUnitType || null;
    this.createdAt = data.createdAt || '';
    this.updatedAt = data.updatedAt || '';
    this.billingSolutionRanges = data.billingSolutionRanges || [];
  }

  toJson(): BillingSolutionInterface {
    return {
      id: this.id,
      name: this.name,
      createClaimsBy: this.createClaimsBy,
      totalUnitsBy: this.totalUnitsBy,
      unitConversionType: this.unitConversionType,
      unitConversionMinutes: this.unitConversionMinutes,
      unitConversionUnits: this.unitConversionUnits,
      unitConversionUnitType: this.unitConversionUnitType,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      billingSolutionRangesAttributes: this.billingSolutionRanges?.map(range =>
        range.toJson(),
      ),
    };
  }
}
